import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { useEventListener } from "@vueuse/core"
import { useCookie } from '#app'

function getInitialTheme() {
  if (process.server) {
    const themeCookie = useCookie('theme')
    return themeCookie.value || 'light'
  }

  if (typeof window !== 'undefined') {
    const themeCookie = useCookie('theme')
    if (themeCookie.value) return themeCookie.value
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  return 'light'
}

export default defineNuxtPlugin((app) => {
  const initialTheme = getInitialTheme()

  const vuetify = createVuetify({
    ssr: true,
    theme: {
      defaultTheme: initialTheme,
      themes: {
        light: {
          colors: {
            background: '#ffffff',
            surface: '#F5F5F5',
            primary: "#EAF7FF",
            secondary: '#0027AF',
            error: '#F44336',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107',
            onBackground: '#000000',
            onSurface: '#000000',
            buttonBg: "#0027AF",
          },
        },
        dark: {
          colors: {
            background: '#1E1E1E',
            surface: '#121212',
            primary: "#171717",
            secondary: '#90CAF9',
            error: '#F44336',
            info: '#29B6F6',
            success: '#4CAF50',
            warning: '#FFC107',
            onBackground: '#ffffff',
            onSurface: '#ffffff',
            buttonBg: "#214AD9",
          },
        },
      },
    },
    icons: { defaultSet: 'mdi', aliases, sets: { mdi } },
  })

  app.vueApp.use(vuetify)

  if (typeof window !== "undefined" && window.matchMedia) {
    const themeCookie = useCookie('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')

    useEventListener(prefersDark, 'change', (e: MediaQueryListEvent) => {
      const newTheme = e.matches ? 'dark' : 'light'
      vuetify.theme.global.name.value = newTheme
      themeCookie.value = newTheme
    })
  }
})